KlaviyoSubscribe.attachToForms('#email_signup', {
  hide_form_on_success: true
});

$(function() {
  if ($('.nivoSlider').length) {
    $('.nivoSlider').nivoSlider({
      effect: 'sliceUp',
      slices: 1,
      animSpeed: 800,
      pauseTime: 5000,
      controlNav: true,
      directionNav: false
    });
  }
 
  
  
  /*if (window.matchMedia('(max-width: 749px)').matches && $('.selector-gun-type').length) {
    $.ajaxSetup({
      cache: true
    });    
    $.getScript('https://www.google-analytics.com/cx/api.js?experiment=VGkOUXsOSmWdUz1KvtFT2A', function() {
      setTimeout([
        function() {},
        function() {
          $('body').addClass('test');
        }
      ][cxApi.chooseVariation()], 1000);
    });
  }*/
});

var YotpoOverride = setInterval(function() {
  if (typeof Yotpo != 'undefined' && typeof Yotpo.Review != 'undefined') {
    Yotpo.Review.prototype.trigger_old = Yotpo.Review.prototype.trigger;
    Yotpo.Review.prototype.trigger = function(e, o) {
      this.trigger_old(e, o);
      if (e == 'save') {
        window._learnq = _learnq || [];
        
        if (this.params.email != undefined) {
          window._learnq.push(['identify', {
            '$email': this.params.email,
            '$first_name': this.params.display_name
          }]);
        }
        
        var params = Object.assign({}, this.params); 
        delete params.$is_session_activity;
        delete params.$use_ip;
        delete params.appkey;
        delete params.email;
        delete params.display_name;
        delete params.product_description;
        delete params.social_link;
        delete params.review_source;
        delete params.utoken;
        delete params.sku;
        params.product_image_url = decodeURIComponent(params.product_image_url);
        window._learnq.push(['track', 'Review Submitted', params]);
      }
    };
    clearTimeout(YotpoOverride);
  }
}, 500);
